import { useEffect, useState } from 'react';
import { useAuth } from '../auth/AuthProvider';
import { getProfile, setUsername, myRuns, deleteAccount, type Profile as P, type MyRun } from './api';
import { supabase } from '../../lib/supabase';
import { status, disconnect } from '../multiplayer/sync';
import { track, setTelemetryUser } from '../../lib/telemetry';
import { consentDate } from '../auth/consent';
import { Link } from 'react-router-dom';

/** Konto-Seite für angemeldete Nutzer: Nutzername, eigene Partien, Abmelden. */
export function Profile() {
  const { user, signOut } = useAuth();
  const [p, setP] = useState<P | null>(null);
  const [name, setName] = useState('');
  const [msg, setMsg] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);
  const [runs, setRuns] = useState<MyRun[]>([]);
  const [cd, setCd] = useState<string | null>(null);
  useEffect(() => { if (user?.id) consentDate(user.id).then(setCd); }, [user?.id]);
  useEffect(() => { getProfile().then((x) => { setP(x); setName(x?.username ?? ''); }); myRuns().then(setRuns); }, [user?.id]);

  const save = async (e: React.FormEvent) => {
    e.preventDefault(); setBusy(true);
    const err = await setUsername(name); setBusy(false);
    setMsg(err ?? 'Gespeichert.'); if (!err) setP((x) => x ? { ...x, username: name.trim() } : x);
  };

  return (
    <section className="screen">
      <div><span className="label">Konto</span><h2>{p?.username ? p.username : 'Angemeldet'}</h2></div>
      <p className="sub">{user?.email}{cd ? <> · <Link to="/datenschutz">Datenschutzerklärung</Link> zugestimmt am {new Date(cd).toLocaleString('de-DE', { dateStyle: 'medium', timeStyle: 'short' })}</> : null}</p>
      <form className="form" onSubmit={save}>
        <label className="label" htmlFor="username">Nutzername in der Bestenliste</label>
        <input id="username" type="text" maxLength={24} value={name} onChange={(e) => setName(e.target.value)} placeholder="z. B. kanzlerin_2029" />
        <div className="actions"><button type="submit" className="yes" disabled={busy || !name.trim()}>Speichern</button>{msg && <span className="sub">{msg}</span>}</div>
      </form>
      <div><span className="label">Eure Partien</span></div>
      {!runs.length ? <p className="sub">Noch keine beendeten Partien.</p> : (
        <div className="lb">{runs.map((r) => <div className="row" key={r.id}><span className="rank">{r.verified ? '✓' : '·'}</span><div className="mi"><b>{r.party_name}</b><span className="sub">{new Date(r.created_at).toLocaleDateString('de-DE')} · {r.legislatures} {r.legislatures === 1 ? 'Legislatur' : 'Legislaturen'} · {r.laws} Gesetze · {r.difficulty}{r.verified ? ' · geprüft' : ''}</span></div><b className="num">{r.score.toLocaleString('de-DE')}</b></div>)}</div>)}
      <div className="actions"><button type="button" onClick={signOut}>Abmelden</button></div>
      <DeleteAccount />
    </section>
  );
}

/** Konto endgültig löschen. Entfernt alle Daten in Supabase und auf Wunsch auch den Spielstand auf diesem Gerät. */
function DeleteAccount() {
  const [open, setOpen] = useState(false); const [word, setWord] = useState(''); const [local, setLocal] = useState(true);
  const [busy, setBusy] = useState(false); const [err, setErr] = useState<string | null>(null);
  const go = async () => {
    setBusy(true); setErr(null);
    if (status()) await disconnect(true);
    const e = await deleteAccount();
    if (e) { setErr(e); setBusy(false); return; }
    track('User.deleted', { localDataRemoved: local });
    setTelemetryUser(null);
    try { await supabase?.auth.signOut({ scope: 'local' }); } catch { /* Konto ist bereits weg */ }
    if (local) { try { for (const k of Object.keys(localStorage)) if (k.startsWith('kabinett')) localStorage.removeItem(k); } catch { /* egal */ } }
    window.location.assign('/?konto=geloescht');
  };
  return (
    <div className="danger">
      <span className="label">Konto löschen</span>
      {!open ? <>
        <p className="sub">Löscht dein Konto und alle zugehörigen Daten unwiderruflich: E-Mail-Adresse, Nutzername, Cloud-Spielstände, Einträge in der Bestenliste, deine Zustimmungen und alle Mehrspieler-Partien, an denen du beteiligt warst.</p>
        <div className="actions"><button type="button" className="warnbtn" onClick={() => setOpen(true)}>Konto löschen …</button></div>
      </> : <>
        <p>Das lässt sich nicht rückgängig machen. Laufende Mehrspieler-Partien mit dir enden auch für deine Mitspieler.</p>
        <label className="consent" htmlFor="dl-local"><input id="dl-local" type="checkbox" checked={local} onChange={(e) => setLocal(e.target.checked)} /><span>Auch den Spielstand auf diesem Gerät löschen</span></label>
        <label className="label" htmlFor="dl-word">Zur Bestätigung LÖSCHEN eintippen</label>
        <input id="dl-word" type="text" value={word} onChange={(e) => setWord(e.target.value)} autoComplete="off" style={{ maxWidth: 220 }} />
        <div className="actions">
          <button type="button" className="warnbtn" disabled={busy || word.trim().toUpperCase() !== 'LÖSCHEN'} onClick={go}>{busy ? 'Wird gelöscht …' : 'Konto endgültig löschen'}</button>
          <button type="button" onClick={() => { setOpen(false); setWord(''); setErr(null); }}>Abbrechen</button>
        </div>
        {err && <span className="sub down">{err}</span>}
      </>}
    </div>
  );
}
